const responseInterceptor = () => (response) => response.data;

export default responseInterceptor;
